export const EVENT_DATE_ENDPOINTS = {
  getEvenDate: "/event-date",
  getEventDateUpcoming: "/event-date/upcoming"
}

export const EVENT_DATE_KEYS = {
  all: ["eventDate"],
  getEventDateList: () => [...EVENT_DATE_KEYS.all, "list"] as const,
  getEventDateUpcoming: () => [...EVENT_DATE_KEYS.all, "upcoming"] as const
} as const

export const SESSION_SUBSCRIBE_ENDPOINTS = {
  getSessionSubscribe: "/session/subscribe",
  postSessionSubscribe: "/session/subscribe"
}

export const SESSION_SUBSCRIBE_KEYS = {
  all: ["session"],
  getSessionSubscribeList: () =>
    [...SESSION_SUBSCRIBE_KEYS.all, "list"] as const
} as const

export const PRESENTATION_ENDPOINTS = {
  detail: (id: number) => `/presentation/${id}`
}
